import type { FilterToggle } from "../fhir-section";
import type { ReportRowData } from "./table-data";
import { IRowNode } from "ag-grid-community";

/**
 * Create dynamic filter toggles based on actual data in rowData
 * Extracts unique note types and specialties from the data
 */
export function createReportsFilterToggles(rowData?: object[]): FilterToggle[] {
  const filterToggles: FilterToggle[] = [];

  if (!rowData || rowData.length === 0) {
    return filterToggles;
  }

  // Extract unique note types
  const noteTypes = new Set<string>();
  const specialties = new Set<string>();

  rowData.forEach((row: IRowNode["data"]) => {
    if (row.noteCategory) {
      noteTypes.add(row.noteCategory);
    }
    if (row.specialty) {
      specialties.add(row.specialty);
    }
  });

  // Create filters for each unique note type
  Array.from(noteTypes)
    .filter(noteCategory => noteCategory !== "-" && noteCategory !== "Imaging")
    .sort()
    .forEach(noteCategory => {
      filterToggles.push({
        label: noteCategory,
        groupLabel: "Category",
        isChecked: false,
        filterFn: (data: ReportRowData) => data.noteCategory === noteCategory,
      });
    });

  // Create filters for each unique specialty
  Array.from(specialties)
    .filter(specialty => specialty !== "-")
    .sort()
    .forEach(specialty => {
      filterToggles.push({
        label: specialty,
        groupLabel: "Specialty",
        isChecked: false,
        filterFn: (data: ReportRowData) => data.specialty === specialty,
      });
    });

  return filterToggles;
}
